import { createSelector } from 'reselect';

export const selectApp = (state) => state.app;
export const selectData = (state) => state.app.data;
export const selectIsPending = createSelector([selectApp], (state) => state.isPending);
export const selectPageTypeId = createSelector([selectApp], (state) => state.pageTypeId);
export const selectHasActivePositionOverlay = createSelector([selectApp], (state) => state.hasActivePositionOverlay);
export const selectHasNewHeader = createSelector([selectApp], (state) => state.hasNewHeader);

export const selectIsVisibleMobileHeaderSearch = createSelector(
	[selectApp],
	(state) => state.isVisibleMobileHeaderSearch,
);
